// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  text-align: center;
}

ion-icon {
  font-size: 1.3rem;
}

.modalContent {
  min-height: 100%;
}

ion-content {
  --ion-background-color: rgb(247, 247, 247);
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/formules/list-formule/list-formule.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAGA;EACI,iBAAA;AAAJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,0CAAA;AADJ","sourcesContent":["ion-title {\r\n    text-align: center;\r\n}\r\n\r\n\r\nion-icon {\r\n    font-size: 1.3rem;\r\n}\r\n\r\n\r\n.modalContent {\r\n    min-height: 100%;\r\n}\r\n\r\nion-content {\r\n    --ion-background-color: rgb(247, 247, 247);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
